module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAAAmCAMAAABZJo0lAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABCUExURUxpceUYMeUYMeYYMugZMuYYMuUYMf/r//FEV/9DXP9/jv99jf99jv9+juUZMeUYMv9/jeUZMuYYMe9AVeUYMf99jd62bzgAAAAUdFJOUwDoyYA2W/oBGAY6tdyDoaheo6Usj/82ewAAAINJREFUSMfN1ksOgCAMRdGngIDgN7r/rRrqFu6gnTA7ScOjRfPDlRKJ1QnEFEisLCCmm8QiiWkmsURiWDoGhqXDMCodhukgsegW271eQPAa2uT1oaMj6PI6tsmFgq46dAmj3wOi8mvVQKwXEFvFYZs4rFcQg5o0jGpyYC2DWBGHnf/5Adp4omnYrogzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/label_activity@2x.png
// module id = 571
// module chunks = 0